import { useEffect } from "react";
import About from "./sections/About";
import Home from "./sections/Home";
import Navigation from "./sections/Navigation";
import Projects from "./sections/Projects";
import Hackthon from "./sections/Hackthon";
import Research from "./sections/Research";
import Blogs from "./sections/Blogs";
import Footer from "./sections/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);

  return (
    <div className="app container-fluid">
      <Navigation />
      <Home />
      <About />
      <Projects />
      <Hackthon />
      {/* <Research /> */}
      <Blogs />
      <Footer />
      <a href="#navbar">
        <span className="floating">
          <i className="fas fa-arrow-up"></i>
        </span>
      </a>
    </div>
  );
}

export default App;
